import React from 'react';
import {Modal, ModalHeader, ModalBody} from 'reactstrap';
import PropTypes from "prop-types";

function ModalSuccess({toggle, successText, isOpen}) {
    return (
            <div>
                <Modal isOpen={isOpen}>
                    <ModalHeader toggle={toggle}>Success</ModalHeader>
                    <ModalBody>{successText}</ModalBody>
                </Modal>
            </div>
        );
}

ModalSuccess.propTypes = {
    successText: PropTypes.string,
    isOpen: PropTypes.func,
    toggle: PropTypes.func,
};

export default ModalSuccess;
